export default "__VITE_ASSET__W1$YEBfL__"